import { Id, Model, Ref } from "./model";
import { User, UserBase, UserDAO } from "./user";
import { makeId, takeId } from "../util/model-util";

export type MediaTransformationKind = "thumb" | "small" | "normal" | "cover" | "card" | "original";

export interface MediaBase extends Model {
	__entity?: "Media";

	contentType: string;
	title?: string;
	path: string;

	createdBy?: Ref<UserBase>;
}

export interface Media extends MediaBase {
	signedUrl?: string;
	originalUrl?: string;

	createdBy?: Ref<User>;
}

export interface MediaDAO extends MediaBase {
	createdBy?: Id<UserDAO>;
}

export enum MediaKind {
	IMAGE = 0,
	VIDEO = 1,
	AUDIO = 2,
	DOCUMENT = 3,
	OTHER = 9
}

export function contentTypeToMediaKind(contentType: string): MediaKind {
	if (contentType.startsWith("image/")) return MediaKind.IMAGE;
	if (contentType.startsWith("video/")) return MediaKind.VIDEO;
	if (contentType.startsWith("audio/")) return MediaKind.AUDIO;
	if (contentType.startsWith("application/pdf")) return MediaKind.DOCUMENT;
	return MediaKind.OTHER;
}

export function idToMediaKind(id: Ref<MediaDAO>): MediaKind {
	id = takeId(id);
	const firstChar = Number(id.charAt(0));
	return isNaN(firstChar) ? MediaKind.OTHER : firstChar;
}

export function makeMediaId(kind: MediaKind): Id<MediaDAO> {
	let id = makeId<MediaDAO>();

	// Replace first character with "data.kind" to bake "kind" into "id"
	const kindId = Number(kind) ?? MediaKind.OTHER;

	if (kindId < 0 || kindId > MediaKind.OTHER) throw new Error(`Invalid media kind: ${kind}`);

	return `${kindId}${id.slice(1)}` as Id<MediaDAO>;
}
